export default "__VITE_ASSET__bascccjC__"